import { useState, useEffect } from 'react';

const usePWAInstall = () => {
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState(null);
  const [isInstalled, setIsInstalled] = useState(false);
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);

  useEffect(() => {
    const beforeInstallPromptHandler = (e) => {
      e.preventDefault();
      console.log('Evento beforeinstallprompt capturado');
      // Capturar el prompt independientemente de la URL en desarrollo
      const isLocalhost = window.location.hostname === 'localhost' ||
        window.location.hostname === '[::1]' ||
        window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/);

      if (isLocalhost || window.location.href.includes('leonesnh.uruguay30.com')) {
        console.log('Evento beforeinstallprompt capturado en URL válida');
        setPromptInstall(e);
        setSupportsPWA(true);
        setShowInstallPrompt(true);
      } else {
        console.log('URL no válida para instalar PWA');
      }
    };

    const checkPWASupport = async () => {
      const hasServiceWorker = 'serviceWorker' in navigator;
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
      
      console.log('PWA Support Check:', {
        hasServiceWorker,
        isStandalone
      });
      
      if (window.navigator.standalone === true || isStandalone) {
        setIsInstalled(true);
        return;
      }

      if ('getInstalledRelatedApps' in navigator) {
        try {
          const relatedApps = await navigator.getInstalledRelatedApps();
          if (relatedApps.length > 0) {
            setIsInstalled(true);
          }
        } catch (error) {
          console.log('Error al verificar apps instaladas:', error);
        }
      }
    };

    const displayModeHandler = (e) => {
      if (e.matches) {
        setIsInstalled(true);
      }
    };

    const appInstalledHandler = () => {
      setIsInstalled(true);
      setShowInstallPrompt(false);
      console.log('PWA instalada correctamente');
    };
    
    // Inicializar
    checkPWASupport();
    
    // Event listeners
    window.addEventListener('beforeinstallprompt', beforeInstallPromptHandler);
    window.addEventListener('appinstalled', appInstalledHandler);
    
    const mediaQuery = window.matchMedia('(display-mode: standalone)');
    mediaQuery.addListener(displayModeHandler);

    // Cleanup
    return () => {
      window.removeEventListener('beforeinstallprompt', beforeInstallPromptHandler);
      window.removeEventListener('appinstalled', appInstalledHandler);
      mediaQuery.removeListener(displayModeHandler);
    };
  }, []);

  const installApp = async () => {
    if (!promptInstall) {
      console.log('No hay prompt de instalación disponible');
      return false;
    }

    try {
      await promptInstall.prompt();
      const { outcome } = await promptInstall.userChoice;
      
      if (outcome === 'accepted') {
        console.log('Usuario aceptó la instalación');
        setIsInstalled(true);
        setShowInstallPrompt(false);
        return true;
      } else {
        console.log('Usuario rechazó la instalación');
        return false;
      }
    } catch (error) {
      console.error('Error durante la instalación:', error);
      return false;
    } finally {
      setPromptInstall(null);
    }
  };

  const dismissInstallPrompt = () => {
    setShowInstallPrompt(false);
    setPromptInstall(null);
  };

  return {
    supportsPWA,
    isInstalled,
    showInstallPrompt,
    installApp,
    dismissInstallPrompt
  };
};

export default usePWAInstall;